import createActionTypes from "./createActionTypes";

export const namespace = "USER";

export const types = createActionTypes(namespace, [
  "RESET_GEOLOCATION",
  "SET_GEOLOCATION",
  "GEOCODE_AND_SET_GEOLOCATION",
  "GET_CURRENT_POSITION",
  "SET_ID",
  "SET_SESSION_ID",
]);

export const resetGeolocation = () => ({
  type: types.RESET_GEOLOCATION,
});

export const setGeolocation = (geolocation) => {
  return {
    type: types.SET_GEOLOCATION,
    payload: { geolocation },
  };
};

export const geocodeAndSetGeolocation = (location) => ({
  type: types.GEOCODE_AND_SET_GEOLOCATION,
  payload: { location },
});

export const getCurrentPosition = () => ({
  type: types.GET_CURRENT_POSITION,
});

export const setId = (id) => ({
  type: types.SET_ID,
  payload: { id },
});

export const setSessionId = (sessionId) => ({
  type: types.SET_SESSION_ID,
  payload: { sessionId },
});
